import { CommonPurchaseCost } from '../purchase-cost'

export const UnitedStatesPurchaseCost = {
  ...CommonPurchaseCost,
} as const
